import { SelectData } from "../../models";

export class TaskConstants {
  // Status
  public static readonly TASK_STATUS_COMPLETE = "Complete";

  public static readonly TASK_STATUS_TO_DO = "To do";

  public static readonly TASK_STATUS_UNASSIGNED = "Unassigned";

  public static readonly TASK_STATUS_IN_PROGRESS = "In progress";

  public static readonly TASK_STATUS_IN_REVIEW = "In review";

  public static readonly TASK_STATUS_BLOCKED = "Blocked";

  // Resolution
  public static readonly TASK_RESOLUTION_FINISHED = "Finished";

  public static readonly TASK_RESOLUTION_WONT_DO = "Won't do";

  public static readonly TASK_RESOLUTION_DUPLICATE = "Duplicate";

  public static readonly DEFAULT_TASK = {
    deadlineDate: null,
    isMandatory: null,
    isMilestone: null,
    status: null,
    keyDate: null,
    repeat: null,
    description: null,
    name: null,
    visibility: null,
    assignedToUserUuid: null,
    assignedToUserName: null,
    ownerOrganisationUuid: null,
    relateToActivity: false,
    activityUuid: null,
    stepUuid: null,
    phase: null,
    uuid: null,
    rowVersion: null,
    resolution: null,
  };

  public static readonly STATUS_SELECT_DATA = [
    { key: TaskConstants.TASK_STATUS_UNASSIGNED, value: TaskConstants.TASK_STATUS_UNASSIGNED },
    { key: TaskConstants.TASK_STATUS_TO_DO, value: TaskConstants.TASK_STATUS_TO_DO },
    { key: TaskConstants.TASK_STATUS_IN_PROGRESS, value: TaskConstants.TASK_STATUS_IN_PROGRESS },
    { key: TaskConstants.TASK_STATUS_IN_REVIEW, value: TaskConstants.TASK_STATUS_IN_REVIEW },
    { key: TaskConstants.TASK_STATUS_COMPLETE, value: TaskConstants.TASK_STATUS_COMPLETE },
    { key: TaskConstants.TASK_STATUS_BLOCKED, value: TaskConstants.TASK_STATUS_BLOCKED },
  ] as SelectData;

  public static readonly ASSIGNED_TASK_STATUS_SELECT_DATA = [
    { key: TaskConstants.TASK_STATUS_TO_DO, value: TaskConstants.TASK_STATUS_TO_DO },
    { key: TaskConstants.TASK_STATUS_IN_PROGRESS, value: TaskConstants.TASK_STATUS_IN_PROGRESS },
    { key: TaskConstants.TASK_STATUS_IN_REVIEW, value: TaskConstants.TASK_STATUS_IN_REVIEW },
    { key: TaskConstants.TASK_STATUS_COMPLETE, value: TaskConstants.TASK_STATUS_COMPLETE },
    { key: TaskConstants.TASK_STATUS_BLOCKED, value: TaskConstants.TASK_STATUS_BLOCKED },
  ];

  public static readonly RESOLUTION_SELECT_DATA = [
    { key: TaskConstants.TASK_RESOLUTION_FINISHED, value: TaskConstants.TASK_RESOLUTION_FINISHED },
    { key: TaskConstants.TASK_RESOLUTION_WONT_DO, value: TaskConstants.TASK_RESOLUTION_WONT_DO },
    { key: TaskConstants.TASK_RESOLUTION_DUPLICATE, value: TaskConstants.TASK_RESOLUTION_DUPLICATE },
  ];
}
